var mainMenu = function(){	
	var recipientBtn,
	subMenu,
	
	init = function(){
		recipientBtn = document.getElementById("recipientMenu") ? document.getElementById("recipientMenu") : null;
		
		if(recipientBtn){
			subMenu = recipientBtn.nextElementSibling;
			
			var subMenuLinks = [].slice.call(subMenu.querySelectorAll("a")),
			lastLink = subMenuLinks[subMenuLinks.length - 1];

			recipientBtn.addEventListener("click", submenuView);		
			lastLink.addEventListener("keydown", closeOnTab);
		}	
	},
	submenuView = function(e){
		e.preventDefault();
		if(subMenu.classList.contains("hide")){
			openMenu();
		}else{
			closeMenu();
		}
	},
	openMenu = function(){
		subMenu.classList.remove("hide");
		recipientBtn.setAttribute("aria-expanded", "false");
			
		document.addEventListener("keydown", closeOnEsc);
	},
	closeMenu = function(){
		subMenu.classList.add("hide");
		recipientBtn.setAttribute("aria-expanded", "true");
		
		document.removeEventListener("keydown", closeOnEsc);
	},
	closeOnEsc = function(e){
		if(e.keyCode === 27){
			closeMenu();
			recipientBtn.focus();
		}
	},
	closeOnTab = function(e){
		if(e.keyCode === 9){
			e.preventDefault();
			e.stopPropagation();
			closeMenu();
			recipientBtn.parentNode.nextElementSibling.querySelector("a").focus();
		}
	};
	return {
		init: init
	};
};
(function(){
	var oneByOneMenu = new mainMenu();
	oneByOneMenu.init();
})();